// TODO: update to show completed user rank information

import React from "react";
import PropTypes from "prop-types";
import { I18n } from "lib/I18n";
import setModalAppElement from "lib/setModalAppElement";
import IconContext from "components/utils/IconContext";

setModalAppElement();

export default class AgentblazerTrailCompletedModal extends React.Component {
  static propTypes = {
    description: PropTypes.string.isRequired,
    celebrationHeader: PropTypes.string.isRequired,
    footerCta: PropTypes.string.isRequired,
    agentblazerModalIconUrl: PropTypes.string.isRequired,
    sharing: PropTypes.object.isRequired,
    celebrationHeaderFs: PropTypes.string.isRequired,
    subheadingFs: PropTypes.string.isRequired,
    continueSeries: PropTypes.object,
  };

  state = {
    isOpen: this.props.isOpen
  };

  modal = React.createRef();

  closeModal = () => {
    this.trackModalClose();
    this.setState({ isOpen: false });
    this.resetFocus();
  };

  componentDidMount() {
    this.setLastPageCtaProp();

    if (this.modal.current) {
      this.modal.current.addEventListener("requestclose", this.closeModal);
      window.addEventListener("lpstatechange", this.handleLpStateChange);
    }

    if (window.lpCelebrationState === "agentblazerOpen") {
      this.setState({ isOpen: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isOpen && this.state.isOpen && window.emitter?.emit) {
      /**
       * Notes:
       * - Timeout exists to ensure that the th-streaks-manager's API call finishes before the event
       * is attempted. Otherwise, the emitter's event listener may have not been wired up yet.
       * For localhost testing, you might need to increase this from 500 to ~800ms.
       *
       * - Streaks celebrations should only happen on the unit page before this modal
       * is opened for Trail-complete celebrations. So the Streak-related emitter below
       * exists in case the user returns to this page at a later point in time, after their Streak
       * has been extended by completing the Trail.
       */
      setTimeout(() => {
        window.emitter.emit("custom", {
          name: "award_earned",
          payload: {},
        });
      }, 500);
    }
  }

  handleLpStateChange = (event) => {
    if (event.detail.state === "agentblazerOpen") {
      this.setState({ isOpen: true });
    }
  };

  dispatchTrackEvent = (eventName, payload) => {
    const trackEvent = new CustomEvent("trailhead_track", {
      bubbles: true,
      composed: true,
      detail: {
        eventName,
        payload
      }
    });

    document.dispatchEvent(trackEvent);
  };

  trackModalClose = () => {
    const payload = {
      cta_type: "agentblazer_success_modal_dismissed",
      page_location: window.location.pathname
    };

    this.dispatchTrackEvent("modal_dismissed", payload);
  };

  trackCtaClick = () => {
    const payload = {
      cta_type: "agentblazer_view_dashboard",
      page_location: window.location.pathname
    };

    this.dispatchTrackEvent("cta_clicked", payload);
  };

  resetFocus = () => {
    document.querySelector(".th-content-container").focus();
  };

  localizePath = (path) => {
    return I18n.locale == "en" ? path : `${I18n.locale}${path}`;
  };

  lastPageCtaConfig = () => {
    return {
      href: "/agentblazer",
      label: this.props.lastPageCtaLabel,
      onCtaClick: this.trackCtaClick,
    }
  }

  setLastPageCtaProp = () => {
    const lastPageCta = this.lastPageCtaConfig();

    if (this.modal.current) {
      this.modal.current.lastPageCta = lastPageCta ? { ...lastPageCta } : null;
    }
  };

  renderContinueSeriesCard = () => {
    const trail = this.props.continueSeries.nextTrailConfig;
    const meta = [trail.pointsLabel, trail.estimatedTimeLabel].filter(Boolean).join(" · ");

    return (
      <a className="ab_continue-series-card" href={trail.path}>
        <span
          className="ab_continue-series-card__media"
          style={{ backgroundColor: trail.color }}
        >
          <img src={trail.image} alt="" />
        </span>
        <span className="ab_continue-series-card__text">
          <span className="ab_continue-series-card__pretitle">{trail.pretitle}</span>
          <span className="ab_continue-series-card__title">{trail.title}</span>
          <span className="ab_continue-series-card__description">{trail.description}</span>
          {meta ? <span className="ab_continue-series-card__meta">{meta}</span> : null}
        </span>
      </a>
    );
  };

  renderFullScreenModalContent = () => {
    return (
      <div className="ab_trail-completed-modal--full-screen">
        <div className="ab_data-dust-animation"></div>

        <div className="slds-text-align--center">
          <h1 className="th-celebration-modal__heading">
            {this.props.celebrationHeaderFs}
          </h1>

          <div className="th-badge-reward">
            <img

              src={this.props.agentblazerModalIconUrl}
              alt="trail completed"
            />
          </div>
        </div>
        <div className="ab_trail-completed-modal_content">
          <div className="ab_trail-completed-modal_title">{this.props.subheadingFs}</div>
          <div
            className="trail-completed-modal_description"
            dangerouslySetInnerHTML={{ __html: this.props.description }}
          />
        </div>

        <div className="slds-text-align--center">
          <th-social-sharing
            app-id={this.props.sharing.fbAppId}
            share-url={this.props.sharing.shareUrl}
            server-text={this.props.sharing.serverText}
            public={true}
            facebook-text={this.props.sharing.facebookShareText}
            x-text={this.props.sharing.xShareText}
            threads-text={this.props.sharing.threadsShareText}
            bluesky-text={this.props.sharing.blueskyShareText}
            linkedin-text={"toggle"}
          />
        </div>
      </div>
    );
  };

  renderContinueSeriesPage = () => {
    return (
      <div className="ab_trail-completed-modal--full-screen">
        <div className="slds-text-align--center ab_trail-completed-modal_content">
          <h1 className="th-celebration-modal__heading">
            {this.props.continueSeries.title}
          </h1>

          <div className="slds-p-top_x-large">
            {this.props.continueSeries.description}
          </div>

          <div className="slds-text-align--left">
            {this.renderContinueSeriesCard()}
          </div>
        </div>
      </div>
    );
  };

  modalContentClass = () => {
    return "th-modal__content--full-screen";
  };

  render() {
    return (
      <IconContext>
        <div className="trail-completed-modal_outer">
          <th-celebration-modal
            ref={this.modal}
            open={this.state.isOpen}
            assistive-text="trail completed"
            agentforce
          >
            <div slot="page1" className={this.modalContentClass()}>
              {this.renderFullScreenModalContent()}
            </div>

            {this.props.continueSeries.nextTrailConfig !== null ? (
              <div slot="pageLast" className={this.modalContentClass()}>
                {this.renderContinueSeriesPage()}
              </div>
            ) :(null)}
          </th-celebration-modal>
        </div>
      </IconContext>
    );
  }
}
